import { Component } from '@angular/core';
import { SidebarConfiguration } from '../../../models/sidebar-configuration';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { MenuItem } from 'primeng/api';
import { PanelMenuModule } from 'primeng/panelmenu';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-import-export',
  standalone: true,
  imports: [PanelMenuModule, RouterOutlet],
  templateUrl: './import-export.component.html',
  styleUrl: './import-export.component.scss',
})
export class ImportExportComponent {
  sidebarConfig: SidebarConfiguration = {
    cssClasses: 'w-12',
    icon: 'fas fa-cloud-upload',
    headerText: 'Import und Export',
  };

  items: MenuItem[] = [];

  constructor(private sidebarService: SidebarService) {
    setTimeout(() => {
      this.sidebarService.setConfiguration(this.sidebarConfig);
    }, 10);
    this.buildPanelMenu();
  }

  /**
   * Builds the panel menu and initializes the `items` property with the menu configuration.
   * Each menu item includes a label, an icon, and a routerLink for navigation.
   *
   * @return {void} This method does not return a value.
   */
  buildPanelMenu(): void {
    this.items = [
      {
        label: 'Indikatoren',
        icon: 'fas fa-ruler-vertical',
        routerLink: [{ outlets: { panel: 'indikatoren' } }],
      },
      {
        label: 'Daten',
        icon: 'fas fa-database',
        routerLink: [{ outlets: { panel: 'daten' } }],
      },
      {
        label: 'Geodaten',
        icon: 'fas fa-circle-nodes',
        routerLink: [{ outlets: { panel: 'geo-daten' } }],
      },
      {
        label: 'Standorte',
        icon: 'fas fa-location-dot',
        routerLink: [{ outlets: { panel: 'poi' } }],
      },
    ];
  }
}
